module.exports = __webpack_public_path__ + "static/media/whoops1.00b248d9.gif";